import { useState } from "react";

// ─── MOCK DATA ────────────────────────────────────────────────────────────────
const LISTINGS = [
  { id:1, title:"Kadıköy'de Ferah 2+1",   price:18500, district:"Kadıköy",  city:"İstanbul", rooms:"2+1",    sqm:85,  floor:3, img:"https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&q=80", owner:"Mehmet Y.", ownerRating:4.8, available:true,  tags:["Evcil Hayvan OK","Asansör","Otopark"] },
  { id:2, title:"Beşiktaş Merkez 1+1",    price:22000, district:"Beşiktaş", city:"İstanbul", rooms:"1+1",    sqm:55,  floor:5, img:"https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=600&q=80", owner:"Ayşe K.",   ownerRating:4.6, available:true,  tags:["Deniz Manzarası","Yeni Bina"] },
  { id:3, title:"Çankaya Sakin 3+1",      price:15000, district:"Çankaya",  city:"Ankara",   rooms:"3+1",    sqm:120, floor:2, img:"https://images.unsplash.com/photo-1484154218962-a197022b5858?w=600&q=80", owner:"Ali R.",    ownerRating:4.9, available:true,  tags:["Bahçe","Kapalı Mutfak"] },
  { id:4, title:"Alsancak Stüdyo Daire",  price:12000, district:"Alsancak", city:"İzmir",    rooms:"Stüdyo", sqm:40,  floor:4, img:"https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&q=80", owner:"Zeynep A.", ownerRating:4.7, available:false, tags:["Denize Yakın","Mobilyalı"] },
  { id:5, title:"Nişantaşı Lüks 2+1",    price:35000, district:"Şişli",    city:"İstanbul", rooms:"2+1",    sqm:95,  floor:7, img:"https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&q=80", owner:"Can B.",    ownerRating:5.0, available:true,  tags:["Concierge","Gym","Havuz"] },
  { id:6, title:"Bornova Üniversite Yakını",price:9500, district:"Bornova", city:"İzmir",    rooms:"1+1",    sqm:50,  floor:1, img:"https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=600&q=80", owner:"Fatma D.", ownerRating:4.4, available:true,  tags:["Öğrenci Dostu","Market Yakın"] },
];

const PAYMENTS_HISTORY = [
  { id:1, month:"Mart 2025",   date:"03.03.2025", amount:18500, status:"paid",     method:"Kredi Kartı",    ref:"KD-2025-0312" },
  { id:2, month:"Şubat 2025",  date:"02.02.2025", amount:18500, status:"paid",     method:"Banka Havalesi", ref:"KD-2025-0248" },
  { id:3, month:"Ocak 2025",   date:"05.01.2025", amount:18500, status:"paid",     method:"Kredi Kartı",    ref:"KD-2025-0189" },
  { id:4, month:"Aralık 2024", date:"01.12.2024", amount:17000, status:"paid",     method:"Kredi Kartı",    ref:"KD-2024-1143" },
  { id:5, month:"Kasım 2024",  date:"15.11.2024", amount:17000, status:"overdue",  method:"—",              ref:"—" },
  { id:6, month:"Nisan 2025",  date:"01.04.2025", amount:18500, status:"upcoming", method:"—",              ref:"—" },
];

const CONTRACTS = [
  { id:1, property:"Kadıköy'de Ferah 2+1", tenant:"Selin Öztürk", start:"01.01.2025", end:"31.12.2025", amount:18500, status:"active" },
  { id:2, property:"Beşiktaş 1+1",         tenant:"Emre Koç",     start:"01.06.2024", end:"31.05.2025", amount:21000, status:"expiring" },
];

const CONTRACT_CLAUSES = [
  { id:"sublease", title:"Alt Kiralama Yasağı",    desc:"Kiracı, mülkü başkasına kiralayamaz.", required:true },
  { id:"increase", title:"Kira Artış Sınırı",      desc:"Yıllık artış yasal TÜFE oranını geçemez.", required:true },
  { id:"pet",      title:"Evcil Hayvan Yasağı",    desc:"Yazılı izin olmaksızın evcil hayvan beslenemez.", required:false },
  { id:"repair",   title:"Onarım Sorumluluğu",     desc:"1.000 ₺ altı kiracıya, üstü ev sahibine aittir.", required:false },
  { id:"noise",    title:"Gürültü Saatleri",        desc:"22:00–08:00 arası gürültüden kaçınılır.", required:false },
  { id:"smoking",  title:"Sigara Yasağı",           desc:"Mülk içinde sigara içilmesi yasaktır.", required:false },
];

const INSTALLMENTS = [
  { count:1, extra:0 }, { count:2, extra:0 }, { count:3, extra:0 },
  { count:6, extra:2.5 }, { count:9, extra:4.0 }, { count:12, extra:6.5 },
];

// ─── STYLES ───────────────────────────────────────────────────────────────────
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;700&family=DM+Sans:wght@300;400;500;600&display=swap');
*{margin:0;padding:0;box-sizing:border-box;}
:root{
  --forest:#1a3c34;--forest-mid:#2d5a4e;--forest-light:#3d7a6a;
  --mint:#52c9a0;--mint-light:#a8edcf;--cream:#faf8f3;
  --sand:#f0ebe0;--sand-dark:#e2d9c8;--terra:#c95f3a;--terra-light:#e8845f;
  --charcoal:#1c2b28;--muted:#7a9490;--white:#fff;
  --shadow:0 4px 24px rgba(26,60,52,.10);--shadow-lg:0 12px 48px rgba(26,60,52,.18);
}
body{font-family:'DM Sans',sans-serif;background:var(--cream);color:var(--charcoal);}

/* NAV */
.nav{background:var(--forest);padding:0 28px;height:64px;display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;z-index:200;box-shadow:0 2px 20px rgba(0,0,0,.2);}
.nav-logo{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:var(--mint);cursor:pointer;flex-shrink:0;}
.nav-logo span{color:#fff;}
.nav-links{display:flex;gap:2px;}
.nav-link{padding:8px 14px;border-radius:8px;font-size:14px;font-weight:500;color:rgba(255,255,255,.65);cursor:pointer;border:none;background:transparent;transition:all .2s;font-family:'DM Sans',sans-serif;}
.nav-link:hover{color:#fff;background:rgba(255,255,255,.08);}
.nav-link.active{color:var(--mint);background:rgba(82,201,160,.12);}
.nav-btn{padding:8px 18px;background:var(--mint);color:var(--forest);border:none;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer;transition:all .2s;font-family:'DM Sans',sans-serif;white-space:nowrap;}
.nav-btn:hover{background:var(--mint-light);}

/* HERO */
.hero{background:linear-gradient(135deg,var(--forest) 0%,var(--forest-mid) 60%,var(--forest-light) 100%);padding:72px 32px;text-align:center;position:relative;overflow:hidden;}
.hero::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse at 70% 50%,rgba(82,201,160,.15) 0%,transparent 60%);}
.hero-tag{display:inline-block;background:rgba(82,201,160,.2);color:var(--mint);border:1px solid rgba(82,201,160,.3);padding:5px 14px;border-radius:20px;font-size:12px;font-weight:600;margin-bottom:20px;}
.hero h1{font-family:'Playfair Display',serif;font-size:clamp(32px,5vw,56px);font-weight:700;color:#fff;line-height:1.15;margin-bottom:16px;}
.hero h1 em{color:var(--mint);font-style:normal;}
.hero p{font-size:17px;color:rgba(255,255,255,.7);max-width:500px;margin:0 auto 36px;line-height:1.6;}
.search-bar{background:#fff;border-radius:14px;padding:7px 7px 7px 18px;display:flex;align-items:center;gap:10px;max-width:560px;margin:0 auto;box-shadow:var(--shadow-lg);}
.search-bar input{flex:1;border:none;outline:none;font-family:'DM Sans',sans-serif;font-size:14px;color:var(--charcoal);background:transparent;}
.search-bar input::placeholder{color:var(--muted);}
.search-btn{background:var(--terra);color:#fff;border:none;border-radius:10px;padding:11px 22px;font-size:14px;font-weight:600;cursor:pointer;font-family:'DM Sans',sans-serif;transition:all .2s;}
.search-btn:hover{background:var(--terra-light);}

/* STATS */
.stats-bar{background:var(--sand);padding:20px 32px;display:flex;justify-content:center;gap:56px;border-bottom:1px solid rgba(0,0,0,.06);}
.stat{text-align:center;}
.stat-num{font-family:'Playfair Display',serif;font-size:26px;font-weight:700;color:var(--forest);}
.stat-label{font-size:12px;color:var(--muted);margin-top:2px;}

/* SECTION */
.section{padding:44px 32px;max-width:1200px;margin:0 auto;width:100%;}
.section-header{display:flex;align-items:baseline;justify-content:space-between;margin-bottom:24px;}
.section-title{font-family:'Playfair Display',serif;font-size:24px;font-weight:700;color:var(--charcoal);}
.see-all{font-size:13px;color:var(--forest-light);cursor:pointer;font-weight:500;background:none;border:none;text-decoration:underline;}

/* FILTERS */
.filter-bar{display:flex;gap:8px;margin-bottom:24px;flex-wrap:wrap;}
.filter-chip{padding:7px 16px;border-radius:24px;border:1.5px solid var(--sand-dark);background:#fff;font-size:13px;font-weight:500;cursor:pointer;color:var(--charcoal);transition:all .2s;font-family:'DM Sans',sans-serif;}
.filter-chip:hover{border-color:var(--mint);}
.filter-chip.active{background:var(--forest);color:#fff;border-color:var(--forest);}

/* LISTING GRID */
.listing-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(290px,1fr));gap:22px;}
.listing-card{background:#fff;border-radius:16px;overflow:hidden;box-shadow:var(--shadow);cursor:pointer;transition:all .25s;border:1.5px solid transparent;}
.listing-card:hover{transform:translateY(-4px);box-shadow:var(--shadow-lg);border-color:var(--mint);}
.listing-img{width:100%;height:195px;object-fit:cover;display:block;}
.listing-img-wrap{position:relative;}
.listing-badge{position:absolute;top:10px;left:10px;font-size:11px;font-weight:600;padding:3px 10px;border-radius:20px;}
.listing-badge.available{background:var(--mint);color:var(--forest);}
.listing-badge.unavailable{background:var(--terra);color:#fff;}
.listing-body{padding:16px;}
.listing-price{font-family:'Playfair Display',serif;font-size:21px;font-weight:700;color:var(--forest);}
.listing-price span{font-size:12px;font-weight:400;color:var(--muted);font-family:'DM Sans',sans-serif;}
.listing-title{font-size:14px;font-weight:500;color:var(--charcoal);margin:5px 0 3px;}
.listing-meta{font-size:12px;color:var(--muted);margin-bottom:10px;}
.listing-tags{display:flex;gap:5px;flex-wrap:wrap;margin-bottom:12px;}
.tag{background:var(--sand);color:var(--forest-mid);font-size:11px;font-weight:500;padding:2px 9px;border-radius:20px;}
.listing-footer{display:flex;align-items:center;justify-content:space-between;padding-top:10px;border-top:1px solid var(--sand);}
.owner-info{display:flex;align-items:center;gap:7px;}
.owner-avatar{width:26px;height:26px;background:var(--forest-mid);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:600;color:#fff;}
.owner-name{font-size:12px;color:var(--muted);}
.rating{font-size:13px;color:var(--terra);font-weight:600;}

/* DASHBOARD */
.dash-wrap{padding:36px 40px;max-width:1100px;margin:0 auto;}
.dash-greeting{font-family:'Playfair Display',serif;font-size:26px;color:var(--charcoal);margin-bottom:4px;}
.dash-subtitle{font-size:14px;color:var(--muted);margin-bottom:28px;}
.dash-cards{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;margin-bottom:28px;}
.dash-card{background:#fff;border-radius:14px;padding:18px;box-shadow:var(--shadow);border-left:4px solid transparent;}
.dash-card.green{border-color:var(--mint);}
.dash-card.terra{border-color:var(--terra);}
.dash-card.forest{border-color:var(--forest);}
.dash-card.sand{border-color:#d4a76a;}
.dash-card-label{font-size:11px;color:var(--muted);font-weight:600;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px;}
.dash-card-value{font-family:'Playfair Display',serif;font-size:26px;font-weight:700;color:var(--charcoal);}
.dash-card-sub{font-size:11px;color:var(--muted);margin-top:3px;}
.dash-grid{display:grid;grid-template-columns:1fr 1fr;gap:22px;}
.dash-panel{background:#fff;border-radius:14px;padding:22px;box-shadow:var(--shadow);}
.dash-panel h3{font-family:'Playfair Display',serif;font-size:17px;margin-bottom:16px;color:var(--charcoal);}

/* PAYMENT ROWS */
.pay-row{display:flex;align-items:center;justify-content:space-between;padding:11px 0;border-bottom:1px solid var(--sand);}
.pay-row:last-child{border-bottom:none;}
.pay-month{font-size:14px;font-weight:500;}
.pay-amount{font-size:14px;font-weight:600;color:var(--forest);}
.pay-status{font-size:11px;font-weight:600;padding:3px 10px;border-radius:20px;}
.pay-status.paid{background:rgba(82,201,160,.15);color:#1a7a54;}
.pay-status.upcoming{background:rgba(201,95,58,.12);color:var(--terra);}

/* CONTRACT ITEMS */
.contract-item{padding:14px;border:1.5px solid var(--sand-dark);border-radius:12px;margin-bottom:10px;cursor:pointer;transition:all .2s;}
.contract-item:hover{border-color:var(--mint);}
.contract-header{display:flex;justify-content:space-between;align-items:start;margin-bottom:6px;}
.contract-name{font-size:14px;font-weight:600;}
.contract-status{font-size:11px;font-weight:600;padding:3px 10px;border-radius:20px;}
.contract-status.active{background:rgba(82,201,160,.15);color:#1a7a54;}
.contract-status.expiring{background:rgba(201,95,58,.12);color:var(--terra);}
.contract-detail{font-size:12px;color:var(--muted);}

/* TABS */
.tabs{display:flex;gap:0;border-bottom:2px solid var(--sand-dark);margin-bottom:24px;}
.tab-btn{padding:10px 20px;font-size:14px;font-weight:500;color:var(--muted);cursor:pointer;border:none;background:none;border-bottom:2px solid transparent;margin-bottom:-2px;font-family:'DM Sans',sans-serif;transition:all .2s;}
.tab-btn.active{color:var(--forest);border-bottom-color:var(--forest);font-weight:600;}

/* CONTRACT BUILDER */
.contract-layout{display:grid;grid-template-columns:260px 1fr;min-height:calc(100vh - 64px);}
.contract-sidebar{background:var(--forest);padding:36px 24px;position:sticky;top:64px;height:calc(100vh - 64px);overflow-y:auto;}
.c-sidebar-title{font-family:'Playfair Display',serif;font-size:18px;color:#fff;margin-bottom:4px;}
.c-sidebar-sub{font-size:12px;color:rgba(255,255,255,.45);margin-bottom:28px;}
.c-steps{display:flex;flex-direction:column;gap:3px;}
.c-step{display:flex;align-items:flex-start;gap:12px;padding:12px 14px;border-radius:10px;cursor:pointer;transition:all .2s;border:1.5px solid transparent;}
.c-step.active{background:rgba(82,201,160,.12);border-color:rgba(82,201,160,.3);}
.c-step.done .c-step-num{background:rgba(82,201,160,.3);color:var(--mint);}
.c-step-num{width:24px;height:24px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;flex-shrink:0;background:rgba(255,255,255,.1);color:rgba(255,255,255,.45);transition:all .2s;}
.c-step.active .c-step-num{background:var(--mint);color:var(--forest);}
.c-step-label{font-size:13px;font-weight:500;color:rgba(255,255,255,.45);}
.c-step.active .c-step-label{color:#fff;font-weight:600;}
.c-step.done .c-step-label{color:var(--mint-light);}
.c-step-desc{font-size:11px;color:rgba(255,255,255,.3);}
.c-progress-bar{margin-top:32px;height:3px;background:rgba(255,255,255,.1);border-radius:4px;overflow:hidden;}
.c-progress-fill{height:100%;background:var(--mint);border-radius:4px;transition:width .4s ease;}
.c-progress-label{font-size:11px;color:rgba(255,255,255,.35);margin-top:6px;}
.contract-main{padding:40px 44px 72px;}
.step-tag{display:inline-block;background:rgba(82,201,160,.12);color:var(--mint);border:1px solid rgba(82,201,160,.25);padding:3px 12px;border-radius:20px;font-size:11px;font-weight:600;margin-bottom:8px;}
.step-title{font-family:'Playfair Display',serif;font-size:26px;color:var(--charcoal);margin-bottom:6px;}
.step-subtitle{font-size:14px;color:var(--muted);line-height:1.6;margin-bottom:28px;}
.form-section{margin-bottom:26px;}
.form-section-title{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;color:var(--forest-light);margin-bottom:14px;padding-bottom:7px;border-bottom:1px solid var(--sand-dark);}
.form-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
.form-grid-3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:12px;}
.form-group{display:flex;flex-direction:column;gap:5px;}
.form-group.full{grid-column:1/-1;}
.form-label{font-size:12px;font-weight:600;color:var(--charcoal);}
.form-label span{color:var(--terra);}
.form-input{padding:10px 13px;border:1.5px solid var(--sand-dark);border-radius:10px;font-size:13px;font-family:'DM Sans',sans-serif;color:var(--charcoal);background:#fff;outline:none;transition:all .2s;}
.form-input:focus{border-color:var(--mint);box-shadow:0 0 0 3px rgba(82,201,160,.1);}
.form-input::placeholder{color:var(--muted);}
.form-select{padding:10px 36px 10px 13px;border:1.5px solid var(--sand-dark);border-radius:10px;font-size:13px;font-family:'DM Sans',sans-serif;color:var(--charcoal);background:#fff;outline:none;cursor:pointer;appearance:none;transition:all .2s;}
.form-select:focus{border-color:var(--mint);}
.form-textarea{padding:11px 13px;border:1.5px solid var(--sand-dark);border-radius:10px;font-size:13px;font-family:'DM Sans',sans-serif;color:var(--charcoal);background:#fff;outline:none;resize:vertical;min-height:80px;transition:all .2s;line-height:1.6;}
.form-textarea:focus{border-color:var(--mint);}
.amount-wrap{position:relative;}
.amount-prefix{position:absolute;left:13px;top:50%;transform:translateY(-50%);font-size:14px;font-weight:600;color:var(--forest);pointer-events:none;}
.amount-wrap .form-input{padding-left:26px;}
.clause-list{display:flex;flex-direction:column;gap:8px;}
.clause-item{display:flex;align-items:flex-start;gap:12px;padding:14px 16px;background:#fff;border:1.5px solid var(--sand-dark);border-radius:12px;transition:all .2s;cursor:pointer;}
.clause-item.selected{border-color:var(--mint);background:rgba(82,201,160,.04);}
.clause-check{width:18px;height:18px;border-radius:5px;border:2px solid var(--sand-dark);flex-shrink:0;display:flex;align-items:center;justify-content:center;margin-top:1px;transition:all .2s;font-size:10px;color:var(--forest);}
.clause-item.selected .clause-check{background:var(--mint);border-color:var(--mint);}
.clause-title{font-size:13px;font-weight:600;margin-bottom:2px;}
.clause-desc{font-size:12px;color:var(--muted);line-height:1.4;}
.clause-badge{margin-left:auto;flex-shrink:0;font-size:10px;padding:2px 9px;border-radius:20px;font-weight:600;}
.clause-badge.required{background:rgba(201,95,58,.1);color:var(--terra);}
.clause-badge.optional{background:rgba(82,201,160,.1);color:#1a7a54;}
.preview-wrap{background:#fff;border-radius:14px;border:1.5px solid var(--sand-dark);overflow:hidden;box-shadow:var(--shadow);}
.preview-toolbar{background:var(--sand);padding:11px 18px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid var(--sand-dark);}
.preview-toolbar-label{font-size:12px;font-weight:600;color:var(--forest-mid);}
.preview-actions{display:flex;gap:7px;}
.preview-btn{padding:5px 13px;border-radius:7px;font-size:12px;font-weight:600;cursor:pointer;border:none;font-family:'DM Sans',sans-serif;transition:all .2s;}
.preview-btn.outline{background:#fff;color:var(--forest);border:1.5px solid var(--sand-dark);}
.preview-btn.solid{background:var(--forest);color:#fff;}
.contract-doc{padding:36px 42px;font-family:'DM Sans',sans-serif;line-height:1.8;font-size:13px;color:#2a2a2a;max-height:500px;overflow-y:auto;}
.contract-doc h1{font-family:'Playfair Display',serif;font-size:18px;text-align:center;margin-bottom:3px;}
.doc-sub{text-align:center;color:var(--muted);font-size:11px;margin-bottom:24px;}
.contract-doc h2{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.6px;color:var(--forest);margin:18px 0 7px;}
.doc-table{width:100%;border-collapse:collapse;margin:8px 0 14px;font-size:12px;}
.doc-table td{padding:6px 10px;border:1px solid #e0e0e0;}
.doc-table td:first-child{background:var(--sand);font-weight:600;width:36%;}
.hl{background:rgba(255,220,50,.35);padding:0 2px;border-radius:2px;}
.sign-area{display:grid;grid-template-columns:1fr 1fr;gap:28px;margin-top:36px;padding-top:18px;border-top:1px solid #e0e0e0;}
.sign-block{text-align:center;}
.sign-line{border-bottom:1px solid #aaa;margin-bottom:5px;height:32px;}
.sign-label{font-size:11px;color:var(--muted);}
.esign-box{border:2px dashed var(--sand-dark);border-radius:14px;padding:24px;text-align:center;cursor:pointer;transition:all .2s;background:#fff;}
.esign-box:hover{border-color:var(--mint);}
.esign-box.signed{border-color:var(--mint);border-style:solid;background:rgba(82,201,160,.06);}
.esign-icon{font-size:28px;margin-bottom:7px;}
.esign-title{font-size:14px;font-weight:600;margin-bottom:3px;}
.esign-desc{font-size:12px;color:var(--muted);}
.nav-btns{display:flex;align-items:center;justify-content:space-between;margin-top:32px;padding-top:20px;border-top:1px solid var(--sand-dark);}

/* PAYMENT PAGE */
.pay-layout{display:grid;grid-template-columns:1fr 380px;min-height:calc(100vh - 64px);}
.pay-left{padding:40px 48px 72px;max-width:620px;}
.pay-right{background:var(--forest);padding:36px 32px;position:sticky;top:64px;height:calc(100vh - 64px);overflow-y:auto;}
.pay-method-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:4px;}
.pay-method{border:2px solid var(--sand-dark);border-radius:14px;padding:16px 14px;cursor:pointer;transition:all .2s;text-align:center;background:#fff;}
.pay-method:hover{border-color:var(--mint-light);transform:translateY(-1px);}
.pay-method.active{border-color:var(--mint);background:rgba(82,201,160,.05);}
.pay-method-icon{font-size:26px;margin-bottom:7px;}
.pay-method-label{font-size:13px;font-weight:600;}
.pay-method-desc{font-size:11px;color:var(--muted);margin-top:2px;}
.inst-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px;}
.inst-opt{border:1.5px solid var(--sand-dark);border-radius:11px;padding:12px;cursor:pointer;transition:all .2s;}
.inst-opt:hover{border-color:var(--mint-light);}
.inst-opt.active{border-color:var(--mint);background:rgba(82,201,160,.05);}
.inst-count{font-size:14px;font-weight:700;color:var(--forest);}
.inst-amount{font-size:12px;color:var(--muted);margin-top:1px;}
.inst-fee{font-size:10px;margin-top:1px;}
.card-visual{background:linear-gradient(135deg,var(--forest) 0%,var(--forest-light) 100%);border-radius:14px;padding:22px;color:#fff;margin-bottom:18px;position:relative;overflow:hidden;}
.card-visual::before{content:'';position:absolute;right:-20px;top:-20px;width:120px;height:120px;border-radius:50%;background:rgba(255,255,255,.06);}
.card-chip{width:32px;height:24px;background:linear-gradient(135deg,#d4a017,#f0c040);border-radius:4px;margin-bottom:14px;}
.card-number-display{font-size:17px;letter-spacing:3px;font-weight:500;margin-bottom:14px;font-family:monospace;}
.card-bottom{display:flex;justify-content:space-between;}
.card-info-label{font-size:9px;opacity:.6;margin-bottom:2px;text-transform:uppercase;}
.card-info-val{font-size:13px;font-weight:500;}
.hist-row{background:#fff;border-radius:12px;padding:14px 18px;display:flex;align-items:center;gap:14px;box-shadow:var(--shadow);border-left:4px solid transparent;margin-bottom:8px;transition:all .2s;}
.hist-row:hover{transform:translateX(3px);}
.hist-row.paid{border-color:var(--mint);}
.hist-row.upcoming{border-color:var(--terra);}
.hist-row.overdue{border-color:#e53e3e;}
.hist-month{font-size:14px;font-weight:600;}
.hist-detail{font-size:11px;color:var(--muted);margin-top:2px;}
.hist-amount{font-size:16px;font-weight:700;}
.hist-status{font-size:11px;font-weight:700;padding:3px 10px;border-radius:20px;}
.hist-status.paid{background:rgba(82,201,160,.15);color:#1a7a54;}
.hist-status.upcoming{background:rgba(201,95,58,.12);color:var(--terra);}
.hist-status.overdue{background:rgba(229,62,62,.12);color:#c53030;}
.summary-title{font-family:'Playfair Display',serif;font-size:19px;color:#fff;margin-bottom:3px;}
.summary-sub{font-size:12px;color:rgba(255,255,255,.45);margin-bottom:22px;}
.summary-property{background:rgba(255,255,255,.07);border-radius:11px;padding:14px;margin-bottom:18px;}
.summary-prop-name{font-size:13px;font-weight:600;color:#fff;margin-bottom:3px;}
.summary-prop-detail{font-size:11px;color:rgba(255,255,255,.45);}
.summary-rows{display:flex;flex-direction:column;}
.summary-row{display:flex;justify-content:space-between;padding:9px 0;border-bottom:1px solid rgba(255,255,255,.07);}
.summary-row:last-child{border-bottom:none;}
.summary-row-label{font-size:12px;color:rgba(255,255,255,.5);}
.summary-row-val{font-size:12px;font-weight:600;color:#fff;}
.summary-total{background:rgba(82,201,160,.15);border-radius:11px;padding:14px;margin:14px 0;display:flex;justify-content:space-between;align-items:center;border:1px solid rgba(82,201,160,.25);}
.summary-total-label{font-size:13px;color:var(--mint);font-weight:600;}
.summary-total-val{font-family:'Playfair Display',serif;font-size:24px;font-weight:700;color:var(--mint);}
.sec-badges{display:flex;flex-direction:column;gap:7px;margin-top:16px;}
.sec-badge{display:flex;align-items:center;gap:9px;padding:9px 11px;background:rgba(255,255,255,.05);border-radius:9px;}
.sec-badge-icon{font-size:14px;}
.sec-badge-text{font-size:11px;color:rgba(255,255,255,.55);line-height:1.4;}
.sec-badge-text strong{color:rgba(255,255,255,.85);display:block;}

/* PROFILE */
.profile-wrap{padding:36px 40px;max-width:760px;margin:0 auto;}
.profile-header{background:linear-gradient(135deg,var(--forest),var(--forest-mid));border-radius:18px;padding:32px;display:flex;align-items:center;gap:24px;margin-bottom:24px;color:#fff;}
.profile-avatar{width:72px;height:72px;border-radius:50%;background:var(--mint);display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:28px;color:var(--forest);font-weight:700;flex-shrink:0;}
.profile-name{font-family:'Playfair Display',serif;font-size:24px;font-weight:700;margin-bottom:4px;}
.profile-role{display:inline-block;background:rgba(82,201,160,.2);color:var(--mint);border:1px solid rgba(82,201,160,.3);padding:3px 12px;border-radius:20px;font-size:12px;margin-bottom:6px;}
.profile-meta{font-size:13px;opacity:.6;}
.profile-section{background:#fff;border-radius:13px;padding:22px;margin-bottom:18px;box-shadow:var(--shadow);}
.profile-section h3{font-family:'Playfair Display',serif;font-size:16px;margin-bottom:14px;}
.info-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
.info-item label{font-size:11px;color:var(--muted);text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:3px;}
.info-item span{font-size:14px;font-weight:500;}

/* ROLE SELECT */
.role-select{padding:36px 28px;max-width:440px;margin:56px auto;}
.role-cards{display:grid;gap:14px;}
.role-card{border:2px solid var(--sand-dark);border-radius:14px;padding:22px;cursor:pointer;transition:all .2s;}
.role-card:hover{border-color:var(--mint);transform:translateY(-2px);box-shadow:var(--shadow);}
.role-card.selected{border-color:var(--forest);background:rgba(26,60,52,.03);}
.role-icon{font-size:32px;margin-bottom:10px;}
.role-title{font-size:16px;font-weight:600;margin-bottom:3px;}
.role-desc{font-size:12px;color:var(--muted);line-height:1.5;}

/* SHARED BUTTONS */
.btn{padding:11px 26px;border-radius:10px;font-size:14px;font-weight:600;cursor:pointer;border:none;font-family:'DM Sans',sans-serif;transition:all .2s;}
.btn-primary{background:var(--forest);color:#fff;}
.btn-primary:hover{background:var(--forest-mid);transform:translateY(-1px);}
.btn-ghost{background:var(--sand);color:var(--charcoal);}
.btn-ghost:hover{background:var(--sand-dark);}
.btn-terra{background:var(--terra);color:#fff;}
.btn-terra:hover{background:var(--terra-light);}
.btn-mint{background:var(--mint);color:var(--forest);}
.btn-mint:hover{background:var(--mint-light);}
.btn-pay{background:var(--mint);color:var(--forest);width:100%;padding:14px;font-size:15px;border-radius:12px;margin-top:6px;}
.btn-pay:hover{background:var(--mint-light);transform:translateY(-1px);box-shadow:0 6px 20px rgba(82,201,160,.35);}

/* INFO / WARN BOXES */
.info-box{background:rgba(82,201,160,.08);border:1px solid rgba(82,201,160,.2);border-radius:11px;padding:11px 15px;display:flex;gap:9px;margin-bottom:16px;}
.info-box-text{font-size:12px;color:var(--forest-mid);line-height:1.6;}
.warn-box{background:rgba(201,95,58,.07);border:1px solid rgba(201,95,58,.2);border-radius:11px;padding:11px 15px;display:flex;gap:9px;margin-bottom:14px;}
.warn-box-text{font-size:12px;color:var(--terra);line-height:1.6;}

/* MODALS */
.modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:300;backdrop-filter:blur(4px);}
.modal{background:#fff;border-radius:20px;padding:32px;max-width:500px;width:90%;box-shadow:0 24px 80px rgba(0,0,0,.2);}
.modal h2{font-family:'Playfair Display',serif;font-size:22px;margin-bottom:7px;}
.modal p{font-size:13px;color:var(--muted);margin-bottom:20px;line-height:1.6;}
.modal-btns{display:flex;gap:10px;justify-content:flex-end;}

/* SUCCESS */
.success-ring{width:72px;height:72px;border-radius:50%;background:rgba(82,201,160,.15);display:flex;align-items:center;justify-content:center;margin:0 auto 16px;font-size:32px;animation:pop .4s ease;}
@keyframes pop{from{transform:scale(.4);opacity:0}to{transform:scale(1);opacity:1}}
.receipt-box{background:var(--sand);border-radius:11px;padding:16px;margin-bottom:20px;text-align:left;}
.receipt-row{display:flex;justify-content:space-between;font-size:12px;padding:5px 0;border-bottom:1px solid var(--sand-dark);}
.receipt-row:last-child{border-bottom:none;font-weight:700;font-size:14px;}

/* TOAST */
.toast{position:fixed;bottom:28px;right:28px;background:var(--forest);color:#fff;padding:13px 20px;border-radius:11px;font-size:13px;font-weight:500;box-shadow:var(--shadow-lg);z-index:400;animation:slideUp .3s ease;}
@keyframes slideUp{from{transform:translateY(16px);opacity:0}to{transform:translateY(0);opacity:1}}

/* EMPTY */
.empty{text-align:center;padding:56px 32px;color:var(--muted);}
.empty-icon{font-size:44px;margin-bottom:10px;}

@media(max-width:900px){
  .dash-cards{grid-template-columns:1fr 1fr;}
  .dash-grid{grid-template-columns:1fr;}
  .contract-layout{grid-template-columns:1fr;}
  .contract-sidebar{position:static;height:auto;}
  .pay-layout{grid-template-columns:1fr;}
  .pay-right{position:static;height:auto;}
  .nav-links{display:none;}
}
`;

// ─── HELPERS ──────────────────────────────────────────────────────────────────
function Toast({ msg }) { return msg ? <div className="toast">✓ {msg}</div> : null; }

function formatCard(v) { return v.replace(/\D/g,"").slice(0,16).replace(/(.{4})/g,"$1 ").trim(); }
function maskCard(v) { const d=v.replace(/\D/g,""); return d.length<4?"•••• •••• •••• ••••":`•••• •••• •••• ${d.slice(-4)}`; }

// ─── LISTING COMPONENTS ───────────────────────────────────────────────────────
function ListingCard({ l, onClick }) {
  return (
    <div className="listing-card" onClick={()=>onClick(l)}>
      <div className="listing-img-wrap">
        <img src={l.img} alt={l.title} className="listing-img" onError={e=>e.target.style.display='none'} />
        <span className={`listing-badge ${l.available?"available":"unavailable"}`}>{l.available?"Müsait":"Dolu"}</span>
      </div>
      <div className="listing-body">
        <div className="listing-price">₺{l.price.toLocaleString('tr-TR')}<span> / ay</span></div>
        <div className="listing-title">{l.title}</div>
        <div className="listing-meta">📍 {l.district}, {l.city} · {l.rooms} · {l.sqm} m²</div>
        <div className="listing-tags">{l.tags.slice(0,3).map(t=><span key={t} className="tag">{t}</span>)}</div>
        <div className="listing-footer">
          <div className="owner-info"><div className="owner-avatar">{l.owner[0]}</div><span className="owner-name">{l.owner}</span></div>
          <span className="rating">★ {l.ownerRating}</span>
        </div>
      </div>
    </div>
  );
}

// ─── CONTRACT PREVIEW ─────────────────────────────────────────────────────────
function ContractPreview({ data }) {
  const today = new Date().toLocaleDateString('tr-TR');
  return (
    <div className="contract-doc">
      <h1>KİRA SÖZLEŞMESİ</h1>
      <div className="doc-sub">Türk Borçlar Kanunu Madde 299–378 Kapsamında</div>
      <h2>1. Taraflar</h2>
      <table className="doc-table"><tbody>
        <tr><td>KİRALAYAN</td><td><span className="hl">{data.landlordName||"—"}</span></td></tr>
        <tr><td>TC No</td><td>{data.landlordTC||"—"}</td></tr>
        <tr><td>KİRACI</td><td><span className="hl">{data.tenantName||"—"}</span></td></tr>
        <tr><td>TC No</td><td>{data.tenantTC||"—"}</td></tr>
      </tbody></table>
      <h2>2. Mülk</h2>
      <p><strong>Adres:</strong> <span className="hl">{data.address||"—"}</span>{data.city?`, ${data.city}`:""}</p>
      <p><strong>Nitelik:</strong> {data.rooms||"—"} · {data.sqm?data.sqm+" m²":"—"}</p>
      <h2>3. Kira Koşulları</h2>
      <table className="doc-table"><tbody>
        <tr><td>Aylık Kira</td><td><span className="hl">₺{Number(data.rentAmount||0).toLocaleString('tr-TR')}</span></td></tr>
        <tr><td>Depozito</td><td>₺{Number(data.deposit||0).toLocaleString('tr-TR')}</td></tr>
        <tr><td>Başlangıç</td><td>{data.startDate||"—"}</td></tr>
        <tr><td>Bitiş</td><td>{data.endDate||"—"}</td></tr>
        <tr><td>Ödeme Günü</td><td>Her ayın {data.payDay||"1"}. günü</td></tr>
      </tbody></table>
      <h2>4. Hükümler</h2>
      {data.selectedClauses?.map((id,i)=>{const c=CONTRACT_CLAUSES.find(x=>x.id===id);return c?<p key={id}><strong>{i+1}.</strong> {c.desc}</p>:null})}
      {data.customClause&&<p><strong>{(data.selectedClauses?.length||0)+1}.</strong> {data.customClause}</p>}
      <div className="sign-area">
        <div className="sign-block"><div className="sign-line"/><div className="sign-label">Kiralayanın İmzası<br/>{data.landlordName||"—"} · {today}</div></div>
        <div className="sign-block"><div className="sign-line"/><div className="sign-label">Kiracının İmzası<br/>{data.tenantName||"—"} · {today}</div></div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// PAGES
// ═══════════════════════════════════════════════════════════════════════════════

// ── HOME PAGE ──────────────────────────────────────────────────────────────────
function HomePage({ goTo, toast }) {
  const [search, setSearch] = useState("");
  const [city, setCity] = useState("Tümü");
  const [selected, setSelected] = useState(null);
  const [applying, setApplying] = useState(null);
  const [applyForm, setApplyForm] = useState({ name:"", phone:"", income:"", note:"" });

  const filtered = LISTINGS.filter(l =>
    (city==="Tümü"||l.city===city) &&
    (l.title.toLowerCase().includes(search.toLowerCase())||l.district.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div>
      <div className="hero">
        <div className="hero-tag">🏠 Türkiye'nin Kira Yönetim Platformu</div>
        <h1>Kiracılığı <em>kolaylaştırıyoruz</em></h1>
        <p>İlan bul, sözleşme imzala, kira öde — hepsi tek platformda.</p>
        <div className="search-bar">
          <span style={{fontSize:17}}>🔍</span>
          <input placeholder="Semt, ilçe veya şehir ara..." value={search} onChange={e=>setSearch(e.target.value)} />
          <button className="search-btn">Ara</button>
        </div>
      </div>

      <div className="stats-bar">
        {[["2.400+","Aktif İlan"],["1.200+","Mutlu Kiracı"],["850+","Ev Sahibi"],["₺0","Komisyon (Kiracı)"]].map(([n,l])=>(
          <div className="stat" key={l}><div className="stat-num">{n}</div><div className="stat-label">{l}</div></div>
        ))}
      </div>

      <div className="section">
        <div className="section-header">
          <h2 className="section-title">Güncel İlanlar</h2>
          <button className="see-all">Tümünü Gör →</button>
        </div>
        <div className="filter-bar">
          {["Tümü","İstanbul","Ankara","İzmir"].map(c=>(
            <button key={c} className={`filter-chip ${city===c?"active":""}`} onClick={()=>setCity(c)}>{c}</button>
          ))}
          {["1+1","2+1","3+1","Müsait"].map(r=><button key={r} className="filter-chip">{r}</button>)}
        </div>
        {filtered.length===0
          ? <div className="empty"><div className="empty-icon">🏚️</div><p>Ilan bulunamadı.</p></div>
          : <div className="listing-grid">{filtered.map(l=><ListingCard key={l.id} l={l} onClick={setSelected}/>)}</div>
        }
      </div>

      {/* LISTING DETAIL MODAL */}
      {selected && (
        <div className="modal-overlay" onClick={()=>setSelected(null)}>
          <div className="modal" onClick={e=>e.stopPropagation()} style={{maxWidth:560}}>
            <img src={selected.img} alt={selected.title} style={{width:"100%",height:200,objectFit:"cover",borderRadius:12,marginBottom:16}} onError={e=>e.target.style.display='none'} />
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"start",marginBottom:10}}>
              <div><h2 style={{marginBottom:2}}>{selected.title}</h2><p style={{fontSize:13,color:"var(--muted)"}}>📍 {selected.district}, {selected.city}</p></div>
              <div style={{textAlign:"right"}}><div style={{fontFamily:"Playfair Display,serif",fontSize:22,fontWeight:700,color:"var(--forest)"}}>₺{selected.price.toLocaleString('tr-TR')}</div><div style={{fontSize:11,color:"var(--muted)"}}>/ ay</div></div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:14}}>
              {[["Oda",selected.rooms],["Alan",selected.sqm+" m²"],["Kat",selected.floor+". kat"]].map(([l,v])=>(
                <div key={l} style={{background:"var(--sand)",borderRadius:9,padding:"9px 12px"}}><div style={{fontSize:10,color:"var(--muted)",marginBottom:2}}>{l}</div><div style={{fontSize:14,fontWeight:600}}>{v}</div></div>
              ))}
            </div>
            <div className="listing-tags" style={{marginBottom:16}}>{selected.tags.map(t=><span key={t} className="tag">{t}</span>)}</div>
            <div className="modal-btns">
              <button className="btn btn-ghost" onClick={()=>setSelected(null)}>Kapat</button>
              {selected.available && <button className="btn btn-terra" onClick={()=>{setApplying(selected);setSelected(null);}}>Başvur</button>}
            </div>
          </div>
        </div>
      )}

      {/* APPLY MODAL */}
      {applying && (
        <div className="modal-overlay" onClick={()=>setApplying(null)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <h2>Başvuru Formu</h2>
            <p>{applying.title} için başvuruyorsunuz.</p>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              <div className="form-group"><label className="form-label">Ad Soyad</label><input className="form-input" placeholder="Adınız soyadınız" value={applyForm.name} onChange={e=>setApplyForm({...applyForm,name:e.target.value})} /></div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                <div className="form-group"><label className="form-label">Telefon</label><input className="form-input" placeholder="05XX XXX XX XX" value={applyForm.phone} onChange={e=>setApplyForm({...applyForm,phone:e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Aylık Gelir</label><input className="form-input" placeholder="₺35.000" value={applyForm.income} onChange={e=>setApplyForm({...applyForm,income:e.target.value})} /></div>
              </div>
              <div className="form-group"><label className="form-label">Not</label><textarea className="form-textarea" placeholder="Kısa bir not..." value={applyForm.note} onChange={e=>setApplyForm({...applyForm,note:e.target.value})} /></div>
            </div>
            <div className="modal-btns" style={{marginTop:16}}>
              <button className="btn btn-ghost" onClick={()=>setApplying(null)}>İptal</button>
              <button className="btn btn-primary" onClick={()=>{setApplying(null);toast("Başvurunuz ev sahibine iletildi!");}}>Gönder</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── DASHBOARD PAGE ────────────────────────────────────────────────────────────
function DashboardPage({ role, goTo }) {
  const [tab, setTab] = useState("ozet");
  const isL = role==="landlord";

  return (
    <div className="dash-wrap">
      <div className="dash-greeting">Hoş geldin, {isL?"Mehmet Bey 👋":"Selin Hanım 👋"}</div>
      <div className="dash-subtitle">{isL?"Mülklerinizin özeti aşağıda.":"Kira durumunuz ve belgeleriniz burada."}</div>

      <div className="dash-cards">
        {(isL
          ? [["Toplam Mülk","3","green","2 kiralık, 1 boş"],["Bu Ay Gelir","₺57.000","terra","+%8 geçen ay"],["Aktif Sözleşme","2","forest","1 ay içinde bitiyor"],["Bekleyen Başvuru","4","sand","İnceleme bekliyor"]]
          : [["Güncel Kira","₺18.500","green","/ aylık"],["Sonraki Ödeme","1 Nisan","terra","24 gün kaldı"],["Sözleşme Bitiş","31.12.2025","forest","9 ay kaldı"],["Ödeme Puanı","100/100","sand","Mükemmel"]]
        ).map(([label,val,color,sub])=>(
          <div key={label} className={`dash-card ${color}`}>
            <div className="dash-card-label">{label}</div>
            <div className="dash-card-value">{val}</div>
            <div className="dash-card-sub">{sub}</div>
          </div>
        ))}
      </div>

      <div className="tabs">
        {(isL
          ? [["ozet","Özet"],["sozlesmeler","Sözleşmeler"],["odemeler","Ödemeler"],["ilanlar","İlanlarım"]]
          : [["ozet","Özet"],["odemeler","Ödemeler"],["sozlesme","Sözleşmem"]]
        ).map(([k,v])=>(
          <button key={k} className={`tab-btn ${tab===k?"active":""}`} onClick={()=>setTab(k)}>{v}</button>
        ))}
      </div>

      {(tab==="ozet"||tab==="odemeler") && (
        <div className="dash-grid">
          <div className="dash-panel">
            <h3>💳 Ödeme Geçmişi</h3>
            {PAYMENTS_HISTORY.slice(0,4).map(p=>(
              <div className="pay-row" key={p.id}>
                <div><div className="pay-month">{p.month}</div><div style={{fontSize:11,color:"var(--muted)"}}>{p.date}</div></div>
                <div className="pay-amount">₺{p.amount.toLocaleString('tr-TR')}</div>
                <span className={`pay-status ${p.status}`}>{p.status==="paid"?"Ödendi":p.status==="upcoming"?"Yaklaşıyor":"Gecikmiş"}</span>
              </div>
            ))}
            <button className="btn btn-mint" style={{marginTop:14,width:"100%",fontSize:13}} onClick={()=>goTo("payment")}>
              Ödeme Sayfasına Git →
            </button>
          </div>
          <div className="dash-panel">
            <h3>📄 {isL?"Aktif Sözleşmeler":"Sözleşmem"}</h3>
            {CONTRACTS.slice(0,isL?2:1).map(c=>(
              <div className="contract-item" key={c.id} onClick={()=>goTo("contract")}>
                <div className="contract-header">
                  <div className="contract-name">{c.property}</div>
                  <span className={`contract-status ${c.status}`}>{c.status==="active"?"Aktif":"Bitiyor"}</span>
                </div>
                <div className="contract-detail">{isL?`Kiracı: ${c.tenant}`:"Ev Sahibi: Mehmet Yılmaz"} · ₺{c.amount.toLocaleString('tr-TR')}/ay</div>
                <div className="contract-detail" style={{marginTop:3}}>{c.start} → {c.end}</div>
                <div style={{display:"flex",gap:7,marginTop:10}}>
                  <button className="btn btn-ghost" style={{fontSize:12,padding:"5px 12px"}}>PDF İndir</button>
                  {c.status==="expiring"&&<button className="btn btn-terra" style={{fontSize:12,padding:"5px 12px"}}>Yenile</button>}
                </div>
              </div>
            ))}
            <button className="btn btn-primary" style={{marginTop:14,width:"100%",fontSize:13}} onClick={()=>goTo("contract")}>
              + Yeni Sözleşme Oluştur
            </button>
          </div>
        </div>
      )}

      {tab==="ilanlar"&&isL&&(
        <div>
          <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}>
            <button className="btn btn-primary">+ Yeni İlan Ekle</button>
          </div>
          <div className="listing-grid">
            {LISTINGS.slice(0,3).map(l=><ListingCard key={l.id} l={l} onClick={()=>{}}/>)}
          </div>
        </div>
      )}

      {(tab==="sozlesmeler"||tab==="sozlesme")&&(
        <div style={{maxWidth:560}}>
          {CONTRACTS.map(c=>(
            <div className="contract-item" key={c.id} onClick={()=>goTo("contract")}>
              <div className="contract-header">
                <div className="contract-name">{c.property}</div>
                <span className={`contract-status ${c.status}`}>{c.status==="active"?"Aktif":"Yakında Bitiyor"}</span>
              </div>
              <div className="contract-detail">Kiracı: {c.tenant} · ₺{c.amount.toLocaleString('tr-TR')}/ay</div>
              <div className="contract-detail" style={{marginTop:3}}>{c.start} → {c.end}</div>
              <div style={{display:"flex",gap:7,marginTop:10}}>
                <button className="btn btn-ghost" style={{fontSize:12,padding:"5px 12px"}}>📄 PDF</button>
                <button className="btn btn-ghost" style={{fontSize:12,padding:"5px 12px"}}>✍️ E-İmza</button>
                {c.status==="expiring"&&<button className="btn btn-terra" style={{fontSize:12,padding:"5px 12px"}}>Yenile</button>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── CONTRACT PAGE ─────────────────────────────────────────────────────────────
const C_STEPS = [
  {id:1,label:"Taraflar",desc:"Ev sahibi & kiracı"},
  {id:2,label:"Mülk",desc:"Adres & özellikler"},
  {id:3,label:"Kira Koşulları",desc:"Tutar & süre"},
  {id:4,label:"Maddeler",desc:"Ek hükümler"},
  {id:5,label:"Önizleme",desc:"İncele"},
  {id:6,label:"E-İmza",desc:"İmzala & gönder"},
];

function ContractPage({ goTo, toast }) {
  const [step, setStep] = useState(1);
  const [done, setDone] = useState(false);
  const [lSigned, setLSigned] = useState(false);
  const [tSigned, setTSigned] = useState(false);
  const [d, setD] = useState({
    landlordName:"Mehmet Yılmaz", landlordTC:"12345678901", landlordPhone:"0532 111 22 33",
    tenantName:"", tenantTC:"", tenantPhone:"",
    address:"", city:"İstanbul", sqm:"", rooms:"2+1",
    rentAmount:"", deposit:"", startDate:"", endDate:"", payDay:"1",
    selectedClauses:["sublease","increase"], customClause:"",
  });
  const set = (k,v) => setD(p=>({...p,[k]:v}));
  const toggleClause = id => set("selectedClauses", d.selectedClauses.includes(id)?d.selectedClauses.filter(x=>x!==id):[...d.selectedClauses,id]);
  const progress = ((step-1)/(C_STEPS.length-1))*100;

  if(done) return (
    <div style={{textAlign:"center",padding:"72px 32px",maxWidth:500,margin:"0 auto"}}>
      <div className="success-ring">🎉</div>
      <div style={{fontFamily:"Playfair Display,serif",fontSize:28,marginBottom:8}}>Sözleşme Tamamlandı!</div>
      <div style={{fontSize:14,color:"var(--muted)",lineHeight:1.7,marginBottom:24}}>{d.landlordName} ve {d.tenantName||"kiracı"} arasında kira sözleşmesi oluşturuldu.</div>
      <div className="receipt-box">
        {[["Referans","#KD-2025-0"+Math.floor(800+Math.random()*99)],["Tarih",new Date().toLocaleDateString('tr-TR')],["Tutar",`₺${Number(d.rentAmount||0).toLocaleString('tr-TR')}/ay`]].map(([l,v])=>(
          <div className="receipt-row" key={l}><span style={{color:"var(--muted)"}}>{l}</span><strong>{v}</strong></div>
        ))}
      </div>
      <div style={{display:"flex",gap:10,justifyContent:"center"}}>
        <button className="btn btn-ghost" onClick={()=>{setStep(1);setDone(false);setLSigned(false);setTSigned(false);}}>+ Yeni Sözleşme</button>
        <button className="btn btn-primary" onClick={()=>goTo("dashboard")}>Dashboard →</button>
      </div>
    </div>
  );

  return (
    <div className="contract-layout">
      <div className="contract-sidebar">
        <div className="c-sidebar-title">Sözleşme Oluştur</div>
        <div className="c-sidebar-sub">6 adımda tamamlayın</div>
        <div className="c-steps">
          {C_STEPS.map(s=>(
            <div key={s.id} className={`c-step ${step===s.id?"active":""} ${step>s.id?"done":""}`} onClick={()=>step>s.id&&setStep(s.id)}>
              <div className="c-step-num">{step>s.id?"✓":s.id}</div>
              <div><div className="c-step-label">{s.label}</div><div className="c-step-desc">{s.desc}</div></div>
            </div>
          ))}
        </div>
        <div className="c-progress-bar"><div className="c-progress-fill" style={{width:`${progress}%`}}/></div>
        <div className="c-progress-label">%{Math.round(progress)} tamamlandı</div>
      </div>

      <div className="contract-main">
        <div className="step-tag">Adım {step} / {C_STEPS.length}</div>
        <div className="step-title">{C_STEPS[step-1].label}</div>

        {step===1 && <>
          <div className="step-subtitle">Ev sahibi ve kiracı bilgileri.</div>
          <div className="form-section">
            <div className="form-section-title">Ev Sahibi</div>
            <div className="form-grid">
              <div className="form-group"><label className="form-label">Ad Soyad <span>*</span></label><input className="form-input" value={d.landlordName} onChange={e=>set("landlordName",e.target.value)} /></div>
              <div className="form-group"><label className="form-label">TC Kimlik No <span>*</span></label><input className="form-input" value={d.landlordTC} onChange={e=>set("landlordTC",e.target.value)} maxLength={11} /></div>
              <div className="form-group"><label className="form-label">Telefon</label><input className="form-input" value={d.landlordPhone} onChange={e=>set("landlordPhone",e.target.value)} /></div>
              <div className="form-group"><label className="form-label">E-posta</label><input className="form-input" placeholder="ornek@email.com" /></div>
            </div>
          </div>
          <div className="form-section">
            <div className="form-section-title">Kiracı</div>
            <div className="form-grid">
              <div className="form-group"><label className="form-label">Ad Soyad <span>*</span></label><input className="form-input" value={d.tenantName} onChange={e=>set("tenantName",e.target.value)} placeholder="Selin Öztürk" /></div>
              <div className="form-group"><label className="form-label">TC Kimlik No <span>*</span></label><input className="form-input" value={d.tenantTC} onChange={e=>set("tenantTC",e.target.value)} maxLength={11} /></div>
              <div className="form-group"><label className="form-label">Telefon</label><input className="form-input" value={d.tenantPhone} onChange={e=>set("tenantPhone",e.target.value)} /></div>
              <div className="form-group"><label className="form-label">E-posta</label><input className="form-input" placeholder="ornek@email.com" /></div>
            </div>
          </div>
        </>}

        {step===2 && <>
          <div className="step-subtitle">Kiralanan mülkün adres ve özellikleri.</div>
          <div className="form-section">
            <div className="form-section-title">Adres</div>
            <div className="form-grid">
              <div className="form-group full"><label className="form-label">Açık Adres <span>*</span></label><input className="form-input" value={d.address} onChange={e=>set("address",e.target.value)} placeholder="Mahalle, Sokak No, Daire No" /></div>
              <div className="form-group"><label className="form-label">İlçe</label><input className="form-input" placeholder="Kadıköy" /></div>
              <div className="form-group"><label className="form-label">Şehir</label><select className="form-select" value={d.city} onChange={e=>set("city",e.target.value)}>{["İstanbul","Ankara","İzmir","Bursa","Antalya"].map(c=><option key={c}>{c}</option>)}</select></div>
            </div>
          </div>
          <div className="form-section">
            <div className="form-section-title">Özellikler</div>
            <div className="form-grid">
              <div className="form-group"><label className="form-label">Oda</label><select className="form-select" value={d.rooms} onChange={e=>set("rooms",e.target.value)}>{["Stüdyo","1+1","2+1","3+1","4+1"].map(r=><option key={r}>{r}</option>)}</select></div>
              <div className="form-group"><label className="form-label">Alan (m²)</label><input className="form-input" type="number" value={d.sqm} onChange={e=>set("sqm",e.target.value)} placeholder="85" /></div>
            </div>
          </div>
        </>}

        {step===3 && <>
          <div className="step-subtitle">Kira tutarı ve ödeme detayları.</div>
          <div className="form-section">
            <div className="form-section-title">Tutar</div>
            <div className="form-grid">
              <div className="form-group"><label className="form-label">Aylık Kira <span>*</span></label><div className="amount-wrap"><span className="amount-prefix">₺</span><input className="form-input" type="number" value={d.rentAmount} onChange={e=>set("rentAmount",e.target.value)} placeholder="18500" /></div></div>
              <div className="form-group"><label className="form-label">Depozito</label><div className="amount-wrap"><span className="amount-prefix">₺</span><input className="form-input" type="number" value={d.deposit} onChange={e=>set("deposit",e.target.value)} placeholder="37000" /></div></div>
              <div className="form-group"><label className="form-label">Başlangıç</label><input className="form-input" type="date" value={d.startDate} onChange={e=>set("startDate",e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Bitiş</label><input className="form-input" type="date" value={d.endDate} onChange={e=>set("endDate",e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Ödeme Günü</label><select className="form-select" value={d.payDay} onChange={e=>set("payDay",e.target.value)}>{[1,5,10,15,20].map(n=><option key={n} value={n}>Her ayın {n}. günü</option>)}</select></div>
            </div>
          </div>
        </>}

        {step===4 && <>
          <div className="step-subtitle">Sözleşmeye eklenecek hükümler.</div>
          <div className="warn-box"><span>⚠️</span><div className="warn-box-text">Zorunlu maddeler kaldırılamaz.</div></div>
          <div className="clause-list">
            {CONTRACT_CLAUSES.map(c=>(
              <div key={c.id} className={`clause-item ${d.selectedClauses.includes(c.id)?"selected":""}`} onClick={()=>!c.required&&toggleClause(c.id)} style={c.required?{cursor:"default"}:{}}>
                <div className="clause-check">{d.selectedClauses.includes(c.id)&&"✓"}</div>
                <div style={{flex:1}}><div className="clause-title">{c.title}</div><div className="clause-desc">{c.desc}</div></div>
                <span className={`clause-badge ${c.required?"required":"optional"}`}>{c.required?"Zorunlu":"İsteğe Bağlı"}</span>
              </div>
            ))}
          </div>
          <div className="form-section" style={{marginTop:20}}>
            <div className="form-section-title">Özel Madde</div>
            <textarea className="form-textarea" value={d.customClause} onChange={e=>set("customClause",e.target.value)} placeholder="Özel bir madde ekleyin..." />
          </div>
        </>}

        {step===5 && <>
          <div className="step-subtitle">Sözleşmeyi inceleyin.</div>
          <div className="preview-wrap">
            <div className="preview-toolbar">
              <span className="preview-toolbar-label">📄 Kira Sözleşmesi Taslağı</span>
              <div className="preview-actions">
                <button className="preview-btn outline">🖨️ Yazdır</button>
                <button className="preview-btn solid">⬇️ PDF</button>
              </div>
            </div>
            <ContractPreview data={d} />
          </div>
        </>}

        {step===6 && <>
          <div className="step-subtitle">Her iki taraf dijital olarak imzalamalıdır.</div>
          <div className="info-box"><span>🔒</span><div className="info-box-text">E-imzalar 5070 sayılı Kanun kapsamında hukuki geçerlilik taşır.</div></div>
          <div style={{display:"grid",gap:12,marginBottom:20}}>
            <div className={`esign-box ${lSigned?"signed":""}`} onClick={()=>setLSigned(true)}>
              {lSigned ? <><div className="esign-icon">✅</div><div className="esign-title">Ev Sahibi İmzaladı</div><div className="esign-desc">{d.landlordName}</div></>
                       : <><div className="esign-icon">✍️</div><div className="esign-title">Ev Sahibi Olarak İmzala</div><div className="esign-desc">Tıklayın</div></>}
            </div>
            <div className={`esign-box ${tSigned?"signed":""}`} onClick={()=>setTSigned(true)}>
              {tSigned ? <><div className="esign-icon">✅</div><div className="esign-title">Kiracı İmzaladı</div><div className="esign-desc">{d.tenantName||"Kiracı"}</div></>
                       : <><div className="esign-icon">📲</div><div className="esign-title">Kiracıya İmza Daveti Gönder</div><div className="esign-desc">Tıklayın</div></>}
            </div>
          </div>
          {lSigned&&tSigned&&<div className="info-box"><span>🎉</span><div className="info-box-text">Her iki taraf imzaladı! Tamamlayabilirsiniz.</div></div>}
        </>}

        <div className="nav-btns">
          {step>1 ? <button className="btn btn-ghost" onClick={()=>setStep(step-1)}>← Geri</button> : <button className="btn btn-ghost" onClick={()=>goTo("dashboard")}>← Dashboard</button>}
          {step<6
            ? <button className="btn btn-primary" onClick={()=>setStep(step+1)}>Devam Et →</button>
            : <button className="btn btn-mint" style={{opacity:lSigned&&tSigned?1:.4}} onClick={()=>(lSigned&&tSigned)&&setDone(true)}>✓ Sözleşmeyi Tamamla</button>}
        </div>
      </div>
    </div>
  );
}

// ── PAYMENT PAGE ──────────────────────────────────────────────────────────────
function PaymentPage({ goTo }) {
  const [tab, setTab] = useState("pay");
  const [method, setMethod] = useState("card");
  const [installment, setInstallment] = useState(1);
  const [card, setCard] = useState({number:"",name:"",expiry:"",cvv:""});
  const [step, setStep] = useState(1);
  const [success, setSuccess] = useState(false);
  const [cvvVis, setCvvVis] = useState(false);

  const amount = 18500;
  const inst = INSTALLMENTS.find(i=>i.count===installment);
  const total = amount*(1+(inst?.extra||0)/100);
  const perMonth = total/installment;
  const methodLabel = {card:"Kredi Kartı",havale:"Banka Havalesi",iyzico:"iyzico",saved:"Kayıtlı Kart"}[method];
  const stepLabels = ["Yöntem","Bilgiler","Onayla"];

  return (
    <div>
      {success && (
        <div className="modal-overlay" onClick={()=>{setSuccess(false);setStep(1);}}>
          <div className="modal" onClick={e=>e.stopPropagation()} style={{textAlign:"center"}}>
            <div className="success-ring">✅</div>
            <div style={{fontFamily:"Playfair Display,serif",fontSize:22,marginBottom:6}}>Ödeme Başarılı!</div>
            <div style={{fontSize:13,color:"var(--muted)",marginBottom:18}}>Nisan 2025 kirası ödendi. Makbuz gönderildi.</div>
            <div className="receipt-box">
              {[["Referans","#KD-2025-"+Math.floor(1000+Math.random()*9000)],["Tarih",new Date().toLocaleDateString('tr-TR')],["Yöntem",methodLabel],["Dönem","Nisan 2025"],["Tutar",`₺${Math.round(total).toLocaleString('tr-TR')}`]].map(([l,v])=>(
                <div className="receipt-row" key={l}><span style={{color:"var(--muted)"}}>{l}</span><strong>{v}</strong></div>
              ))}
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"center"}}>
              <button className="btn btn-ghost" onClick={()=>{setSuccess(false);setStep(1);}}>Kapat</button>
              <button className="btn btn-primary" onClick={()=>goTo("dashboard")}>Dashboard →</button>
            </div>
          </div>
        </div>
      )}

      <div className="pay-layout">
        <div className="pay-left">
          <div className="tabs">
            {[["pay","Ödeme Yap"],["history","Geçmiş"],["auto","Otomatik"]].map(([k,v])=>(
              <button key={k} className={`tab-btn ${tab===k?"active":""}`} onClick={()=>setTab(k)}>{v}</button>
            ))}
          </div>

          {tab==="pay" && <>
            <div className="step-tag">Nisan 2025 Kirası</div>
            <div className="step-title">Ödeme Yap</div>
            <div style={{fontSize:13,color:"var(--muted)",marginBottom:24}}>Son ödeme: <strong>1 Nisan 2025</strong> — 24 gün kaldı.</div>

            {/* STEP INDICATOR */}
            <div style={{display:"flex",marginBottom:28}}>
              {stepLabels.map((s,i)=>(
                <div key={i} style={{flex:1,display:"flex",alignItems:"center"}}>
                  <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center"}}>
                    <div style={{width:26,height:26,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,background:step>i+1?"var(--mint)":step===i+1?"var(--forest)":"var(--sand-dark)",color:step>i+1?"var(--forest)":step===i+1?"#fff":"var(--muted)",transition:"all .3s"}}>{step>i+1?"✓":i+1}</div>
                    <div style={{fontSize:11,color:step===i+1?"var(--forest)":"var(--muted)",marginTop:3,fontWeight:step===i+1?600:400}}>{s}</div>
                  </div>
                  {i<2&&<div style={{height:2,flex:1,background:step>i+1?"var(--mint)":"var(--sand-dark)",marginBottom:16,transition:"background .3s"}}/>}
                </div>
              ))}
            </div>

            {step===1 && <>
              <div style={{background:"#fff",borderRadius:14,padding:20,boxShadow:"var(--shadow)",marginBottom:16}}>
                <div className="form-section-title" style={{marginBottom:12}}>Ödeme Yöntemi</div>
                <div className="pay-method-grid">
                  {[{k:"card",icon:"💳",label:"Kredi Kartı",desc:"Tüm kartlar"},{k:"iyzico",icon:"🔐",label:"iyzico",desc:"Güvenli ödeme"},{k:"havale",icon:"🏦",label:"Banka Havalesi",desc:"EFT / SWIFT"},{k:"saved",icon:"⭐",label:"Kayıtlı Kart",desc:"•••• 4242"}].map(m=>(
                    <div key={m.k} className={`pay-method ${method===m.k?"active":""}`} onClick={()=>setMethod(m.k)}>
                      <div className="pay-method-icon">{m.icon}</div>
                      <div className="pay-method-label">{m.label}</div>
                      <div className="pay-method-desc">{m.desc}</div>
                    </div>
                  ))}
                </div>
              </div>
              {(method==="card"||method==="saved")&&(
                <div style={{background:"#fff",borderRadius:14,padding:20,boxShadow:"var(--shadow)",marginBottom:16}}>
                  <div className="form-section-title" style={{marginBottom:12}}>Taksit</div>
                  <div className="inst-grid">
                    {INSTALLMENTS.map(inst=>(
                      <div key={inst.count} className={`inst-opt ${installment===inst.count?"active":""}`} onClick={()=>setInstallment(inst.count)}>
                        <div className="inst-count">{inst.count===1?"Tek Çekim":`${inst.count} Taksit`}</div>
                        <div className="inst-amount">₺{(amount*(1+inst.extra/100)/inst.count).toLocaleString('tr-TR',{maximumFractionDigits:0})}/ay</div>
                        <div className="inst-fee" style={{color:inst.extra?'var(--terra)':'var(--forest)'}}>{inst.extra?`+%${inst.extra}`:"Faizsiz"}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <button className="btn btn-pay" onClick={()=>setStep(2)}>Devam Et →</button>
            </>}

            {step===2 && <>
              {method==="card"&&<>
                <div className="card-visual">
                  <div className="card-chip"/>
                  <div className="card-number-display">{card.number?maskCard(card.number):"•••• •••• •••• ••••"}</div>
                  <div className="card-bottom">
                    <div><div className="card-info-label">Kart Sahibi</div><div className="card-info-val">{card.name||"AD SOYAD"}</div></div>
                    <div><div className="card-info-label">Son Kullanma</div><div className="card-info-val">{card.expiry||"MM/YY"}</div></div>
                  </div>
                </div>
                <div className="info-box"><span>🔒</span><div className="info-box-text">Kart bilgileriniz 256-bit SSL ile şifrelenir, saklanmaz.</div></div>
                <div className="form-group"><label className="form-label">Kart Numarası</label><input className="form-input" placeholder="0000 0000 0000 0000" maxLength={19} value={formatCard(card.number)} onChange={e=>setCard({...card,number:e.target.value.replace(/\s/g,"")})} /></div>
                <div className="form-group"><label className="form-label">Kart Üzerindeki Ad</label><input className="form-input" placeholder="AD SOYAD" value={card.name} onChange={e=>setCard({...card,name:e.target.value.toUpperCase()})} /></div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                  <div className="form-group"><label className="form-label">Son Kullanma</label><input className="form-input" placeholder="AA/YY" maxLength={5} value={card.expiry} onChange={e=>{let v=e.target.value.replace(/\D/g,"");if(v.length>=2)v=v.slice(0,2)+"/"+v.slice(2,4);setCard({...card,expiry:v});}} /></div>
                  <div className="form-group"><label className="form-label">CVV</label><div style={{position:"relative"}}><input className="form-input" type={cvvVis?"text":"password"} placeholder="•••" maxLength={4} value={card.cvv} onChange={e=>setCard({...card,cvv:e.target.value})} style={{paddingRight:38}} /><button onClick={()=>setCvvVis(!cvvVis)} style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",fontSize:14}}>{cvvVis?"🙈":"👁️"}</button></div></div>
                </div>
              </>}
              {method==="havale"&&<>
                <div className="info-box"><span>ℹ️</span><div className="info-box-text">Açıklama kısmına referans numarasını yazmayı unutmayın.</div></div>
                <div style={{background:"#fff",borderRadius:13,padding:18,boxShadow:"var(--shadow)"}}>
                  {[["Banka","Ziraat Bankası"],["Hesap","Mehmet Yılmaz"],["IBAN","TR12 0001 0017 4523 4567 8901 26"],["Referans","KD-NISAN-2025"]].map(([l,v])=>(
                    <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"10px 0",borderBottom:"1px solid var(--sand)",fontSize:13}}><span style={{color:"var(--muted)"}}>{l}</span><strong style={{fontFamily:l==="IBAN"?"monospace":"inherit"}}>{v}</strong></div>
                  ))}
                </div>
              </>}
              {(method==="saved"||method==="iyzico")&&<div className="info-box"><span>{method==="saved"?"⭐":"🔐"}</span><div className="info-box-text">{method==="saved"?"Visa •••• 4242 ile tek tıkla ödeme.":"iyzico güvenli ödeme sayfasına yönlendirileceksiniz."}</div></div>}
              <div style={{display:"flex",gap:10,marginTop:20}}>
                <button className="btn btn-ghost" onClick={()=>setStep(1)}>← Geri</button>
                <button className="btn btn-pay" style={{flex:1}} onClick={()=>setStep(3)}>Devam Et →</button>
              </div>
            </>}

            {step===3 && <>
              <div style={{background:"#fff",borderRadius:13,padding:20,boxShadow:"var(--shadow)",marginBottom:16}}>
                <div className="form-section-title" style={{marginBottom:12}}>Ödeme Özeti</div>
                {[["Mülk","Kadıköy'de Ferah 2+1"],["Dönem","Nisan 2025"],["Yöntem",methodLabel],["Taksit",installment===1?"Tek çekim":`${installment} × ₺${Math.round(perMonth).toLocaleString('tr-TR')}`],["İşlem Ücreti",inst?.extra?`+%${inst.extra}`:"Ücretsiz"]].map(([l,v])=>(
                  <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"9px 0",borderBottom:"1px solid var(--sand)",fontSize:13}}><span style={{color:"var(--muted)"}}>{l}</span><strong>{v}</strong></div>
                ))}
                <div style={{display:"flex",justifyContent:"space-between",padding:"12px 0 0",fontSize:15}}><strong>Toplam</strong><span style={{fontFamily:"Playfair Display,serif",fontSize:20,fontWeight:700,color:"var(--forest)"}}>₺{Math.round(total).toLocaleString('tr-TR')}</span></div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
                <input type="checkbox" defaultChecked style={{accentColor:"var(--forest)",width:15,height:15}} />
                <label style={{fontSize:12,color:"var(--muted)"}}>Ödeme koşullarını onaylıyorum.</label>
              </div>
              <div style={{display:"flex",gap:10}}>
                <button className="btn btn-ghost" onClick={()=>setStep(2)}>← Geri</button>
                <button className="btn btn-pay" style={{flex:1}} onClick={()=>setSuccess(true)}>🔒 ₺{Math.round(total).toLocaleString('tr-TR')} Öde</button>
              </div>
            </>}
          </>}

          {tab==="history" && <>
            <div className="step-title" style={{marginBottom:6}}>Ödeme Geçmişi</div>
            <div style={{fontSize:13,color:"var(--muted)",marginBottom:20}}>Kadıköy'de Ferah 2+1</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12,marginBottom:22}}>
              {[["₺74K","Toplam Ödendi","var(--forest)"],["4","Zamanında","#3b7dd8"],["1","Gecikme","var(--terra)"]].map(([v,l,c])=>(
                <div key={l} style={{background:"#fff",borderRadius:12,padding:16,textAlign:"center",boxShadow:"var(--shadow)"}}>
                  <div style={{fontFamily:"Playfair Display,serif",fontSize:22,fontWeight:700,color:c}}>{v}</div>
                  <div style={{fontSize:11,color:"var(--muted)",marginTop:2}}>{l}</div>
                </div>
              ))}
            </div>
            {PAYMENTS_HISTORY.sort((a,b)=>b.id-a.id).map(p=>(
              <div key={p.id} className={`hist-row ${p.status}`}>
                <span style={{fontSize:20}}>{p.status==="paid"?"✅":p.status==="upcoming"?"🕐":"⚠️"}</span>
                <div style={{flex:1}}>
                  <div className="hist-month">{p.month}</div>
                  <div className="hist-detail">{p.date} · {p.method}</div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div className="hist-amount">₺{p.amount.toLocaleString('tr-TR')}</div>
                  <span className={`hist-status ${p.status}`}>{p.status==="paid"?"Ödendi":p.status==="upcoming"?"Yaklaşıyor":"Gecikmiş"}</span>
                </div>
              </div>
            ))}
          </>}

          {tab==="auto" && <>
            <div className="step-title" style={{marginBottom:6}}>Otomatik Ödeme</div>
            <div style={{fontSize:13,color:"var(--muted)",marginBottom:20}}>Her ay kira gününde otomatik çekim.</div>
            <div className="info-box"><span>💡</span><div className="info-box-text">Aktifken son ödeme tarihinden 3 gün önce SMS ile bilgilendirilirsiniz.</div></div>
            <div style={{background:"#fff",borderRadius:13,padding:18,boxShadow:"var(--shadow)",marginBottom:16}}>
              {[["📅","Ödeme Günü","Her ayın 1'i"],["💳","Kart","Visa •••• 4242"],["🔔","Bildirim","SMS + E-posta"],["🔴","Durum","Kapalı"]].map(([ic,l,v])=>(
                <div key={l} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"11px 0",borderBottom:"1px solid var(--sand)",fontSize:13}}>
                  <span style={{display:"flex",gap:9,alignItems:"center",color:"var(--muted)"}}>{ic} {l}</span>
                  <strong>{v}</strong>
                </div>
              ))}
            </div>
            <button className="btn btn-pay" onClick={()=>alert("Otomatik ödeme aktive edildi!")}>✅ Otomatik Ödemeyi Aktive Et</button>
          </>}
        </div>

        {/* SIDEBAR */}
        <div className="pay-right">
          <div className="summary-title">Ödeme Özeti</div>
          <div className="summary-sub">Nisan 2025</div>
          <div className="summary-property">
            <div className="summary-prop-name">🏠 Kadıköy'de Ferah 2+1</div>
            <div className="summary-prop-detail">Kadıköy, İstanbul · 01.01.2025 – 31.12.2025</div>
          </div>
          <div className="summary-rows">
            {[["Aylık Kira",`₺${amount.toLocaleString('tr-TR')}`],["Taksit",installment===1?"Tek çekim":`${installment} taksit`],["İşlem Ücreti",inst?.extra?`%${inst.extra}`:"Ücretsiz"],["Vade","1 Nisan 2025"],["Yöntem",methodLabel]].map(([l,v])=>(
              <div className="summary-row" key={l}><span className="summary-row-label">{l}</span><span className="summary-row-val">{v}</span></div>
            ))}
          </div>
          <div className="summary-total">
            <span className="summary-total-label">Toplam</span>
            <span className="summary-total-val">₺{Math.round(total).toLocaleString('tr-TR')}</span>
          </div>
          <div className="sec-badges">
            {[["🔒","256-bit SSL","Güvenli bağlantı"],["🏦","iyzico","Türkiye'nin ödeme altyapısı"],["📄","Otomatik Makbuz","Anında gönderilir"],["↩️","İade Garantisi","Tam iade"]].map(([i,t,d])=>(
              <div className="sec-badge" key={t}><span className="sec-badge-icon">{i}</span><div className="sec-badge-text"><strong>{t}</strong>{d}</div></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ── PROFILE PAGE ──────────────────────────────────────────────────────────────
function ProfilePage({ role }) {
  const isL = role==="landlord";
  return (
    <div className="profile-wrap">
      <div className="profile-header">
        <div className="profile-avatar">{isL?"M":"S"}</div>
        <div>
          <div className="profile-name">{isL?"Mehmet Yılmaz":"Selin Öztürk"}</div>
          <div className="profile-role">{isL?"🏠 Ev Sahibi":"🗝️ Kiracı"}</div>
          <div className="profile-meta">Üyelik: Ocak 2024 · ★ {isL?"4.8":"5.0"} puan</div>
        </div>
      </div>
      <div className="profile-section">
        <h3>Kişisel Bilgiler</h3>
        <div className="info-grid">
          {[["Ad Soyad",isL?"Mehmet Yılmaz":"Selin Öztürk"],["E-posta",isL?"mehmet@email.com":"selin@email.com"],["Telefon","0532 XXX XX XX"],["Kimlik","✅ Doğrulandı"],["Şehir","İstanbul"],["Üyelik","Ocak 2024"]].map(([l,v])=>(
            <div className="info-item" key={l}><label>{l}</label><span>{v}</span></div>
          ))}
        </div>
      </div>
      {isL && (
        <div className="profile-section">
          <h3>Mülk Özeti</h3>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
            {[["3","Toplam Mülk"],["2","Kiradaki"],["₺57K","Aylık Gelir"]].map(([v,l])=>(
              <div key={l} style={{background:"var(--sand)",borderRadius:11,padding:14,textAlign:"center"}}>
                <div style={{fontFamily:"Playfair Display,serif",fontSize:22,fontWeight:700,color:"var(--forest)"}}>{v}</div>
                <div style={{fontSize:11,color:"var(--muted)",marginTop:3}}>{l}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      {!isL && (
        <div className="profile-section">
          <h3>Kira Sicili</h3>
          <div style={{display:"flex",gap:12,padding:14,background:"rgba(82,201,160,.08)",borderRadius:10,border:"1px solid rgba(82,201,160,.2)"}}>
            <span style={{fontSize:26}}>✅</span>
            <div><div style={{fontWeight:600,marginBottom:2}}>Mükemmel ödeme geçmişi</div><div style={{fontSize:13,color:"var(--muted)"}}>14 ay üst üste zamanında ödeme.</div></div>
          </div>
        </div>
      )}
      <div style={{display:"flex",gap:10}}>
        <button className="btn btn-primary">Profili Düzenle</button>
        <button className="btn btn-ghost">Şifre Değiştir</button>
      </div>
    </div>
  );
}

// ── ROLE SELECT ───────────────────────────────────────────────────────────────
function RoleSelect({ onSelect }) {
  const [sel, setSel] = useState(null);
  return (
    <div className="role-select">
      <div style={{fontFamily:"Playfair Display,serif",fontSize:13,color:"var(--mint)",marginBottom:7}}>kiradayım.com</div>
      <div style={{fontFamily:"Playfair Display,serif",fontSize:26,marginBottom:6}}>Ben bir...</div>
      <div style={{fontSize:14,color:"var(--muted)",marginBottom:24}}>Hesabınızı nasıl kullanmak istiyorsunuz?</div>
      <div className="role-cards">
        {[{k:"landlord",icon:"🏠",title:"Ev Sahibiyim",desc:"Mülklerimi yönetmek, sözleşme oluşturmak ve kira takibi yapmak istiyorum."},
          {k:"tenant",  icon:"🗝️",title:"Kiracıyım",   desc:"Daire aramak, başvurmak ve kira ödemelerimi takip etmek istiyorum."}].map(r=>(
          <div key={r.k} className={`role-card ${sel===r.k?"selected":""}`} onClick={()=>setSel(r.k)}>
            <div className="role-icon">{r.icon}</div>
            <div className="role-title">{r.title}</div>
            <div className="role-desc">{r.desc}</div>
          </div>
        ))}
      </div>
      {sel && <button className="btn btn-primary" style={{width:"100%",marginTop:20,padding:14}} onClick={()=>onSelect(sel)}>Devam Et →</button>}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// ROOT APP
// ═══════════════════════════════════════════════════════════════════════════════
export default function App() {
  const [page, setPage] = useState("home");
  const [role, setRole] = useState(null);
  const [showRole, setShowRole] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const toast = (msg) => { setToastMsg(msg); setTimeout(()=>setToastMsg(""),3000); };

  const goTo = (p) => {
    if((p==="dashboard"||p==="profile"||p==="contract"||p==="payment")&&!role){
      setShowRole(true); return;
    }
    setPage(p);
  };

  const NAV = [
    {k:"home",    label:"İlanlar"},
    {k:"dashboard",label:"Dashboard"},
    {k:"contract",label:"Sözleşme"},
    {k:"payment", label:"Ödeme"},
    {k:"profile", label:"Profil"},
  ];

  return (
    <div style={{minHeight:"100vh",display:"flex",flexDirection:"column"}}>
      <style>{CSS}</style>

      <nav className="nav">
        <div className="nav-logo" onClick={()=>setPage("home")}>kirada<span>yım</span></div>
        <div className="nav-links">
          {NAV.map(({k,label})=>(
            <button key={k} className={`nav-link ${page===k?"active":""}`} onClick={()=>goTo(k)}>{label}</button>
          ))}
        </div>
        <button className="nav-btn" onClick={()=>role?setPage("profile"):setShowRole(true)}>
          {role?(role==="landlord"?"🏠 Mehmet Bey":"🗝️ Selin Hanım"):"Giriş Yap"}
        </button>
      </nav>

      {showRole && (
        <div className="modal-overlay" onClick={()=>setShowRole(false)}>
          <div onClick={e=>e.stopPropagation()}>
            <RoleSelect onSelect={r=>{ setRole(r); setShowRole(false); setPage("dashboard"); }} />
          </div>
        </div>
      )}

      <main style={{flex:1}}>
        {page==="home"     && <HomePage     goTo={goTo} toast={toast} />}
        {page==="dashboard"&& <DashboardPage role={role||"tenant"} goTo={goTo} />}
        {page==="contract" && <ContractPage  goTo={goTo} toast={toast} />}
        {page==="payment"  && <PaymentPage   goTo={goTo} />}
        {page==="profile"  && <ProfilePage   role={role||"tenant"} />}
      </main>

      <footer style={{background:"var(--forest)",color:"rgba(255,255,255,.45)",textAlign:"center",padding:"20px",fontSize:12}}>
        © 2025 kiradayım.com — Kiracılığı kolaylaştırıyoruz
      </footer>

      <Toast msg={toastMsg} />
    </div>
  );
}
